/**
 * Category configuration - separates categories from price filters.
 * Categories = Main (nav) + Sub (product assignment). Price filters = price-based only.
 */

// Main categories (for Navbar, Home) - stored in DB with description "Main Category"
export const MAIN_CATEGORY_ROUTES = {
  Jewellery: "/jewellery",
  "Traditional & Western Wear": "/traditional-western",
  "Bags & Purses": "/bags-purses",
};

// Sub-categories for product assignment (NOT price filters)
export const SUB_CATEGORIES = [
  { name: "Earrings", parent: "Jewellery" },
  { name: "Necklaces", parent: "Jewellery" },
  { name: "Bracelets", parent: "Jewellery" },
  { name: "Bangles", parent: "Jewellery" },
  { name: "Rings", parent: "Jewellery" },
  { name: "Traditional Wear", parent: "Traditional & Western Wear" },
  { name: "Western Wear", parent: "Traditional & Western Wear" },
  { name: "Everyday Essentials", parent: "Bags & Purses" },
  { name: "Party & Evening Bags", parent: "Bags & Purses" },
  { name: "Luxury Collection", parent: "Bags & Purses" },
];

// Price bands - products appear here automatically when price <= band (NOT stored as category)
export const PRICE_BANDS = [99, 499, 999, 1499];

// Default categories to sync (Main + Sub + Sub-sub - NO price filters)
export const DEFAULT_CATEGORIES_TO_SYNC = [
  // Main categories
  { name: "Jewellery", description: "Main Category" },
  { name: "Bags & Purses", description: "Main Category" },
  { name: "Traditional & Western Wear", description: "Main Category" },
  // Jewellery sub-categories
  { name: "Earrings", description: "Jewellery Sub-category" },
  { name: "Necklaces", description: "Jewellery Sub-category" },
  { name: "Bracelets", description: "Jewellery Sub-category" },
  { name: "Bangles", description: "Jewellery Sub-category" },
  { name: "Rings", description: "Jewellery Sub-category" },
  // Sub-sub categories under Necklaces
  { name: "Pendant Necklaces", description: "Sub-sub category", parentName: "Necklaces" },
  { name: "Choker Necklaces", description: "Sub-sub category", parentName: "Necklaces" },
  { name: "American Diamond Stone Necklaces", description: "Sub-sub category", parentName: "Necklaces" },
  { name: "CZ Stone Necklaces", description: "Sub-sub category", parentName: "Necklaces" },
  { name: "Matching Necklace + Earrings Sets", description: "Sub-sub category", parentName: "Necklaces" },
  // Sub-sub categories under Earrings
  { name: "Monalisa", description: "Sub-sub category", parentName: "Earrings" },
  { name: "Studs", description: "Sub-sub category", parentName: "Earrings" },
  { name: "Hoops", description: "Sub-sub category", parentName: "Earrings" },
  // Sub-sub categories under Bracelets
  { name: "Gold Bracelets", description: "Sub-sub category", parentName: "Bracelets" },
  { name: "Gold Kada", description: "Sub-sub category", parentName: "Bracelets" },
  { name: "Cuff Bracelets", description: "Sub-sub category", parentName: "Bracelets" },
  // Sub-sub categories under Bangles
  { name: "Anti-Tarnish Gold Plated Bangles", description: "Sub-sub category", parentName: "Bangles" },
  { name: "Brass Gold Bangles", description: "Sub-sub category", parentName: "Bangles" },
  { name: "Unique Fancy Bangles", description: "Sub-sub category", parentName: "Bangles" },
  // Bags & Purses sub-categories
  { name: "Everyday Essentials", description: "Bags Sub-category" },
  { name: "Party & Evening Bags", description: "Bags Sub-category" },
  { name: "Luxury Collection", description: "Bags Sub-category" },
  // Traditional & Western Wear sub-categories
  { name: "Traditional Wear", description: "Clothing Sub-category" },
  { name: "Western Wear", description: "Clothing Sub-category" },
];

// Product category dropdown groups (sub-categories only)
export const PRODUCT_CATEGORY_GROUPS = [
  { label: "Jewellery", categories: ["Earrings", "Necklaces", "Bracelets", "Bangles", "Rings"] },
  { label: "Clothing", categories: ["Traditional Wear", "Western Wear"] },
  { label: "Bags", categories: ["Everyday Essentials", "Party & Evening Bags", "Luxury Collection"] },
];
